// The stage uses CSS zoom. SVG child offsetX/Y are not chart-local pixels.
// Normalize once in capture phase, before zrender consumes the native event.
export function chartPoint (point, rect, width, height) {
  if (!rect.width || !rect.height) return null
  return { zrX: (point.clientX - rect.left) * width / rect.width, zrY: (point.clientY - rect.top) * height / rect.height }
}

export function chartValue (value, unit = '') {
  if (value == null || value === '' || value === '-' || !Number.isFinite(Number(value))) return '—'
  return Number(value).toLocaleString('zh-CN', { maximumFractionDigits: 3 }) + (unit ? ' ' + unit : '')
}

const escape = value => String(value == null ? '' : value).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]))

export function chartTooltip (params, series, labels, slots, unit) {
  const first = Array.isArray(params) ? params[0] : params
  if (!first) return ''
  const index = first.dataIndex
  const row = slots[index]
  const title = escape(labels[index])
  if (row && row.isCollecting) return `<b>${title}</b><span style="float:right;color:#dcc382;margin-left:28px">上报中</span><div style="margin-top:10px;color:#afc5d3">本时段数据正在上报</div>`
  const content = series.map(s => {
    const value = s.values[index]
    const missing = value == null || value === '' || !Number.isFinite(Number(value))
    let text = chartValue(value, unit)
    if (row && s.key === 'grid' && !missing) text = chartValue(Math.abs(value), unit) + (value < 0 ? '（买电）' : value > 0 ? '（卖电）' : '')
    if (row && missing && row.isSettling && s.key !== 'pv') text = '— 获取中'
    return `<div style="display:flex;align-items:center;gap:9px;margin-top:8px"><i style="width:8px;height:8px;border-radius:50%;background:${escape(s.color)}"></i><span>${escape(s.name)}</span><b style="margin-left:auto;padding-left:18px;font-weight:500">${escape(text)}</b></div>`
  }).join('')
  return `<b>${title}</b>${content}`
}
